import { render, staticRenderFns } from "./CompliancePage.vue?vue&type=template&id=ab36cdfc&scoped=true"
import script from "./CompliancePage.vue?vue&type=script&lang=js"
export * from "./CompliancePage.vue?vue&type=script&lang=js"
import style0 from "./CompliancePage.vue?vue&type=style&index=0&id=ab36cdfc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab36cdfc",
  null
  
)

export default component.exports